import { Surah, ScoreClass } from '../types';

// Quran Surah data
export const SURAHS: Surah[] = [
  { number: 1, nameAr: 'الفاتحة', nameEn: 'Al-Fatiha', startPage: 1, endPage: 1 },
  { number: 2, nameAr: 'البقرة', nameEn: 'Al-Baqara', startPage: 2, endPage: 49 },
  { number: 3, nameAr: 'آل عمران', nameEn: 'Ali Imran', startPage: 50, endPage: 76 },
  { number: 4, nameAr: 'النساء', nameEn: 'An-Nisa', startPage: 77, endPage: 106 },
  { number: 5, nameAr: 'المائدة', nameEn: 'Al-Maida', startPage: 106, endPage: 127 },
  { number: 6, nameAr: 'الأنعام', nameEn: 'Al-Anam', startPage: 128, endPage: 150 },
  { number: 7, nameAr: 'الأعراف', nameEn: 'Al-Araf', startPage: 151, endPage: 176 },
  { number: 8, nameAr: 'الأنفال', nameEn: 'Al-Anfal', startPage: 177, endPage: 186 },
  { number: 9, nameAr: 'التوبة', nameEn: 'At-Tawba', startPage: 187, endPage: 207 },
  { number: 10, nameAr: 'يونس', nameEn: 'Yunus', startPage: 208, endPage: 221 },
  { number: 11, nameAr: 'هود', nameEn: 'Hud', startPage: 221, endPage: 235 },
  { number: 12, nameAr: 'يوسف', nameEn: 'Yusuf', startPage: 235, endPage: 248 },
  { number: 13, nameAr: 'الرعد', nameEn: 'Ar-Rad', startPage: 249, endPage: 255 },
  { number: 14, nameAr: 'إبراهيم', nameEn: 'Ibrahim', startPage: 255, endPage: 261 },
  { number: 15, nameAr: 'الحجر', nameEn: 'Al-Hijr', startPage: 262, endPage: 267 },
  { number: 16, nameAr: 'النحل', nameEn: 'An-Nahl', startPage: 267, endPage: 281 },
  { number: 17, nameAr: 'الإسراء', nameEn: 'Al-Isra', startPage: 282, endPage: 293 },
  { number: 18, nameAr: 'الكهف', nameEn: 'Al-Kahf', startPage: 293, endPage: 304 },
  { number: 19, nameAr: 'مريم', nameEn: 'Maryam', startPage: 305, endPage: 312 },
  { number: 20, nameAr: 'طه', nameEn: 'Taha', startPage: 312, endPage: 321 },
  { number: 21, nameAr: 'الأنبياء', nameEn: 'Al-Anbiya', startPage: 322, endPage: 331 },
  { number: 22, nameAr: 'الحج', nameEn: 'Al-Hajj', startPage: 332, endPage: 341 },
  { number: 23, nameAr: 'المؤمنون', nameEn: 'Al-Muminun', startPage: 342, endPage: 349 },
  { number: 24, nameAr: 'النور', nameEn: 'An-Nur', startPage: 350, endPage: 359 },
  { number: 25, nameAr: 'الفرقان', nameEn: 'Al-Furqan', startPage: 359, endPage: 366 },
  { number: 26, nameAr: 'الشعراء', nameEn: 'Ash-Shuara', startPage: 367, endPage: 376 },
  { number: 27, nameAr: 'النمل', nameEn: 'An-Naml', startPage: 377, endPage: 385 },
  { number: 28, nameAr: 'القصص', nameEn: 'Al-Qasas', startPage: 385, endPage: 396 },
  { number: 29, nameAr: 'العنكبوت', nameEn: 'Al-Ankabut', startPage: 396, endPage: 404 },
  { number: 30, nameAr: 'الروم', nameEn: 'Ar-Rum', startPage: 404, endPage: 410 },
  { number: 31, nameAr: 'لقمان', nameEn: 'Luqman', startPage: 411, endPage: 414 },
  { number: 32, nameAr: 'السجدة', nameEn: 'As-Sajda', startPage: 415, endPage: 417 },
  { number: 33, nameAr: 'الأحزاب', nameEn: 'Al-Ahzab', startPage: 418, endPage: 427 },
  { number: 34, nameAr: 'سبأ', nameEn: 'Saba', startPage: 428, endPage: 434 },
  { number: 35, nameAr: 'فاطر', nameEn: 'Fatir', startPage: 434, endPage: 440 },
  { number: 36, nameAr: 'يس', nameEn: 'Ya-Sin', startPage: 440, endPage: 445 },
  { number: 37, nameAr: 'الصافات', nameEn: 'As-Saffat', startPage: 446, endPage: 452 },
  { number: 38, nameAr: 'ص', nameEn: 'Sad', startPage: 453, endPage: 458 },
  { number: 39, nameAr: 'الزمر', nameEn: 'Az-Zumar', startPage: 458, endPage: 467 },
  { number: 40, nameAr: 'غافر', nameEn: 'Ghafir', startPage: 467, endPage: 476 },
  { number: 41, nameAr: 'فصلت', nameEn: 'Fussilat', startPage: 477, endPage: 482 },
  { number: 42, nameAr: 'الشورى', nameEn: 'Ash-Shura', startPage: 483, endPage: 489 },
  { number: 43, nameAr: 'الزخرف', nameEn: 'Az-Zukhruf', startPage: 489, endPage: 495 },
  { number: 44, nameAr: 'الدخان', nameEn: 'Ad-Dukhan', startPage: 496, endPage: 498 },
  { number: 45, nameAr: 'الجاثية', nameEn: 'Al-Jathiya', startPage: 499, endPage: 502 },
  { number: 46, nameAr: 'الأحقاف', nameEn: 'Al-Ahqaf', startPage: 502, endPage: 506 },
  { number: 47, nameAr: 'محمد', nameEn: 'Muhammad', startPage: 507, endPage: 510 },
  { number: 48, nameAr: 'الفتح', nameEn: 'Al-Fath', startPage: 511, endPage: 515 },
  { number: 49, nameAr: 'الحجرات', nameEn: 'Al-Hujurat', startPage: 515, endPage: 517 },
  { number: 50, nameAr: 'ق', nameEn: 'Qaf', startPage: 518, endPage: 520 },
  { number: 51, nameAr: 'الذاريات', nameEn: 'Adh-Dhariyat', startPage: 520, endPage: 523 },
  { number: 52, nameAr: 'الطور', nameEn: 'At-Tur', startPage: 523, endPage: 525 },
  { number: 53, nameAr: 'النجم', nameEn: 'An-Najm', startPage: 526, endPage: 528 },
  { number: 54, nameAr: 'القمر', nameEn: 'Al-Qamar', startPage: 528, endPage: 531 },
  { number: 55, nameAr: 'الرحمن', nameEn: 'Ar-Rahman', startPage: 531, endPage: 534 },
  { number: 56, nameAr: 'الواقعة', nameEn: 'Al-Waqia', startPage: 534, endPage: 537 },
  { number: 57, nameAr: 'الحديد', nameEn: 'Al-Hadid', startPage: 537, endPage: 541 },
  { number: 58, nameAr: 'المجادلة', nameEn: 'Al-Mujadila', startPage: 542, endPage: 545 },
  { number: 59, nameAr: 'الحشر', nameEn: 'Al-Hashr', startPage: 545, endPage: 548 },
  { number: 60, nameAr: 'الممتحنة', nameEn: 'Al-Mumtahina', startPage: 549, endPage: 551 },
  { number: 61, nameAr: 'الصف', nameEn: 'As-Saff', startPage: 551, endPage: 552 },
  { number: 62, nameAr: 'الجمعة', nameEn: 'Al-Jumua', startPage: 553, endPage: 554 },
  { number: 63, nameAr: 'المنافقون', nameEn: 'Al-Munafiqun', startPage: 554, endPage: 555 },
  { number: 64, nameAr: 'التغابن', nameEn: 'At-Taghabun', startPage: 556, endPage: 557 },
  { number: 65, nameAr: 'الطلاق', nameEn: 'At-Talaq', startPage: 558, endPage: 559 },
  { number: 66, nameAr: 'التحريم', nameEn: 'At-Tahrim', startPage: 560, endPage: 561 },
  { number: 67, nameAr: 'الملك', nameEn: 'Al-Mulk', startPage: 562, endPage: 564 },
  { number: 68, nameAr: 'القلم', nameEn: 'Al-Qalam', startPage: 564, endPage: 566 },
  { number: 69, nameAr: 'الحاقة', nameEn: 'Al-Haqqa', startPage: 566, endPage: 568 },
  { number: 70, nameAr: 'المعارج', nameEn: 'Al-Maarij', startPage: 568, endPage: 570 },
  { number: 71, nameAr: 'نوح', nameEn: 'Nuh', startPage: 570, endPage: 571 },
  { number: 72, nameAr: 'الجن', nameEn: 'Al-Jinn', startPage: 572, endPage: 573 },
  { number: 73, nameAr: 'المزمل', nameEn: 'Al-Muzzammil', startPage: 574, endPage: 575 },
  { number: 74, nameAr: 'المدثر', nameEn: 'Al-Muddaththir', startPage: 575, endPage: 577 },
  { number: 75, nameAr: 'القيامة', nameEn: 'Al-Qiyama', startPage: 577, endPage: 578 },
  { number: 76, nameAr: 'الإنسان', nameEn: 'Al-Insan', startPage: 578, endPage: 580 },
  { number: 77, nameAr: 'المرسلات', nameEn: 'Al-Mursalat', startPage: 580, endPage: 581 },
  { number: 78, nameAr: 'النبأ', nameEn: 'An-Naba', startPage: 582, endPage: 583 },
  { number: 79, nameAr: 'النازعات', nameEn: 'An-Naziat', startPage: 583, endPage: 584 },
  { number: 80, nameAr: 'عبس', nameEn: 'Abasa', startPage: 585, endPage: 585 },
  { number: 81, nameAr: 'التكوير', nameEn: 'At-Takwir', startPage: 586, endPage: 586 },
  { number: 82, nameAr: 'الانفطار', nameEn: 'Al-Infitar', startPage: 587, endPage: 587 },
  { number: 83, nameAr: 'المطففين', nameEn: 'Al-Mutaffifin', startPage: 587, endPage: 589 },
  { number: 84, nameAr: 'الانشقاق', nameEn: 'Al-Inshiqaq', startPage: 589, endPage: 589 },
  { number: 85, nameAr: 'البروج', nameEn: 'Al-Buruj', startPage: 590, endPage: 590 },
  { number: 86, nameAr: 'الطارق', nameEn: 'At-Tariq', startPage: 591, endPage: 591 },
  { number: 87, nameAr: 'الأعلى', nameEn: 'Al-Ala', startPage: 591, endPage: 592 },
  { number: 88, nameAr: 'الغاشية', nameEn: 'Al-Ghashiya', startPage: 592, endPage: 592 },
  { number: 89, nameAr: 'الفجر', nameEn: 'Al-Fajr', startPage: 593, endPage: 594 },
  { number: 90, nameAr: 'البلد', nameEn: 'Al-Balad', startPage: 594, endPage: 594 },
  { number: 91, nameAr: 'الشمس', nameEn: 'Ash-Shams', startPage: 595, endPage: 595 },
  { number: 92, nameAr: 'الليل', nameEn: 'Al-Layl', startPage: 595, endPage: 596 },
  { number: 93, nameAr: 'الضحى', nameEn: 'Ad-Duha', startPage: 596, endPage: 596 },
  { number: 94, nameAr: 'الشرح', nameEn: 'Ash-Sharh', startPage: 596, endPage: 596 },
  { number: 95, nameAr: 'التين', nameEn: 'At-Tin', startPage: 597, endPage: 597 },
  { number: 96, nameAr: 'العلق', nameEn: 'Al-Alaq', startPage: 597, endPage: 597 },
  { number: 97, nameAr: 'القدر', nameEn: 'Al-Qadr', startPage: 598, endPage: 598 },
  { number: 98, nameAr: 'البينة', nameEn: 'Al-Bayyina', startPage: 598, endPage: 599 },
  { number: 99, nameAr: 'الزلزلة', nameEn: 'Az-Zalzala', startPage: 599, endPage: 599 },
  { number: 100, nameAr: 'العاديات', nameEn: 'Al-Adiyat', startPage: 599, endPage: 600 },
  { number: 101, nameAr: 'القارعة', nameEn: 'Al-Qaria', startPage: 600, endPage: 600 },
  { number: 102, nameAr: 'التكاثر', nameEn: 'At-Takathur', startPage: 600, endPage: 600 },
  { number: 103, nameAr: 'العصر', nameEn: 'Al-Asr', startPage: 601, endPage: 601 },
  { number: 104, nameAr: 'الهمزة', nameEn: 'Al-Humaza', startPage: 601, endPage: 601 },
  { number: 105, nameAr: 'الفيل', nameEn: 'Al-Fil', startPage: 601, endPage: 601 },
  { number: 106, nameAr: 'قريش', nameEn: 'Quraysh', startPage: 602, endPage: 602 },
  { number: 107, nameAr: 'الماعون', nameEn: 'Al-Maun', startPage: 602, endPage: 602 },
  { number: 108, nameAr: 'الكوثر', nameEn: 'Al-Kawthar', startPage: 602, endPage: 602 },
  { number: 109, nameAr: 'الكافرون', nameEn: 'Al-Kafirun', startPage: 603, endPage: 603 },
  { number: 110, nameAr: 'النصر', nameEn: 'An-Nasr', startPage: 603, endPage: 603 },
  { number: 111, nameAr: 'المسد', nameEn: 'Al-Masad', startPage: 603, endPage: 603 },
  { number: 112, nameAr: 'الإخلاص', nameEn: 'Al-Ikhlas', startPage: 604, endPage: 604 },
  { number: 113, nameAr: 'الفلق', nameEn: 'Al-Falaq', startPage: 604, endPage: 604 },
  { number: 114, nameAr: 'الناس', nameEn: 'An-Nas', startPage: 604, endPage: 604 }
];

export const TOTAL_PAGES = 604;

export const getScoreClass = (score: number): ScoreClass => {
  if (score >= 9) return 'excellent';
  if (score >= 7) return 'good';
  if (score >= 5) return 'fair';
  return 'poor';
};

export const getSurahForPage = (pageNumber: number): Surah | undefined => {
  return SURAHS.find(s => pageNumber >= s.startPage && pageNumber <= s.endPage);
};

/**
 * Parse a datetime string coming from the API. The API stores UTC in
 * 'YYYY-MM-DD HH:MM:SS'; legacy rows may be ISO 8601. Both are treated as UTC.
 */
export const parseUtcDate = (dateString: string): Date => {
  let s = dateString.trim();
  if (!s.includes('T')) {
    s = s.replace(' ', 'T');
  }
  // Append Z unless an explicit timezone is already present
  if (!/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) {
    s += 'Z';
  }
  return new Date(s);
};

/** Format a Date as UTC 'YYYY-MM-DD HH:MM:SS' for the API. */
export const toApiDateTime = (date: Date): string => {
  return date.toISOString().slice(0, 19).replace('T', ' ');
};

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return '-';
  return parseUtcDate(dateString).toLocaleDateString();
};

export const daysSince = (dateString: string | null | undefined): number | null => {
  if (!dateString) return null;
  const date = parseUtcDate(dateString);
  if (isNaN(date.getTime())) return null;
  const now = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
  return Math.max(0, diff);
};

/**
 * Score-weighted review interval (simple spaced repetition): strong pages
 * wait longer between reviews, weak pages come back sooner.
 * Keep in sync with reviewDueCountSql() in api/utils/helpers.php.
 */
export const effectiveReviewInterval = (score: number, maxReviewDays: number): number => {
  if (score >= 9) return maxReviewDays * 1.5;
  if (score >= 7) return maxReviewDays;
  if (score >= 5) return maxReviewDays * 0.75;
  return maxReviewDays * 0.5;
};

/** Total ajza' in the mushaf. */
export const TOTAL_JUZ = 30;

/**
 * Juz' for a page in the standard 604-page Madani mushaf:
 * juz' 1 covers pages 1-21, each following juz' spans 20 pages,
 * and juz' 30 runs to page 604.
 */
export const getJuzForPage = (pageNumber: number): number => {
  if (pageNumber <= 21) return 1;
  return Math.min(TOTAL_JUZ, Math.floor((pageNumber - 22) / 20) + 2);
};

export const getJuzPageRange = (juz: number): { start: number; end: number } => {
  const start = juz === 1 ? 1 : (juz - 2) * 20 + 22;
  const end = juz === TOTAL_JUZ ? 604 : (juz === 1 ? 21 : start + 19);
  return { start, end };
};

/**
 * Calculate memorization strength as a value between 0 and 1
 * Based on score (0-10) and days since last review
 * Higher value = stronger memorization
 */
export const calculateMemorizationStrength = (
  score: number,
  daysSinceReview: number | null,
  maxReviewDays: number = 7
): number => {
  if (daysSinceReview === null) return 0;
  
  // Score factor: normalize 0-10 to 0-1
  const scoreFactor = score / 10;
  
  // Time decay factor: exponential decay based on days since review
  // After maxReviewDays, the decay accelerates
  const decayRate = daysSinceReview <= maxReviewDays 
    ? daysSinceReview / maxReviewDays * 0.3  // Slow decay within review period
    : 0.3 + ((daysSinceReview - maxReviewDays) / maxReviewDays) * 0.7; // Faster decay after
  
  const timeFactor = Math.max(0, 1 - decayRate);
  
  // Combined strength: weighted average (score matters more for recent reviews)
  const strength = scoreFactor * 0.6 + timeFactor * 0.4;
  
  return Math.max(0, Math.min(1, strength));
};

/**
 * Get heat map color based on memorization strength
 * Returns HSL color from red (weak) through yellow to green (strong)
 */
export const getHeatMapColor = (strength: number): string => {
  // Map strength 0-1 to hue 0-120 (red to green)
  const hue = strength * 120;
  // Higher saturation and appropriate lightness for visibility
  const saturation = 70 + strength * 10; // 70-80%
  const lightness = 45 - strength * 10; // 45-35% (darker for stronger)
  
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

/**
 * Get heat map background with appropriate text color
 */
export const getHeatMapStyle = (
  score: number,
  daysSinceReview: number | null,
  maxReviewDays: number = 7
): { background: string; color: string; borderColor: string } => {
  const strength = calculateMemorizationStrength(score, daysSinceReview, maxReviewDays);
  const bgColor = getHeatMapColor(strength);
  
  return {
    background: bgColor,
    color: 'white',
    borderColor: bgColor
  };
};
